/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid200,
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid401,
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid500,
  GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
  GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentBatchStatusGrid.ts";
import { courseRegistrationBatchStatusGridItemViewModelSchema } from "../courseRegistrationBatchStatusGridItemViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentBatchStatusGridQueryParamsSchema =
  z
    .object({
      classStudentId: z.optional(z.coerce.number().int()),
      enrollmentStatus: z.optional(z.coerce.number().int()),
      scholarshipFilter: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentBatchStatusGrid200Schema =
  z.array(
    z.lazy(() => courseRegistrationBatchStatusGridItemViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentBatchStatusGrid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentBatchStatusGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentBatchStatusGrid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentBatchStatusGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentBatchStatusGrid500>;

export const getApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationEnrollmentBatchStatusGrid200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse>;
